import { motion } from "framer-motion";

export const goTo = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionReveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterHeading = ({ index, label, title, sub, align = "left" }) => (
  <SectionReveal className={align === "center" ? "text-center" : ""}>
    <p className="font-nav text-xs font-semibold uppercase tracking-[0.3em] text-[#9B7AE8]" data-testid={`chapter-label-${index}`}>
      {index} // {label}
    </p>
    <h2 className="font-display mt-5 text-3xl font-bold tracking-tight text-[#221A3D] sm:text-4xl lg:text-5xl">
      {title}
    </h2>
    {sub && (
      <p className={`mt-6 max-w-2xl text-base leading-relaxed text-[#5F5780] md:text-lg ${align === "center" ? "mx-auto" : ""}`}>
        {sub}
      </p>
    )}
  </SectionReveal>
);

